import React, {useEffect, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import variablePie from "highcharts/modules/variable-pie.js";
import axios from "axios";
import {strings} from "../../../strings";
import {useDispatch, useSelector} from "react-redux";
import './CounterChart.css';
import {selToken} from "../../../stores/base/baseSlice";
import TextField from "@mui/material/TextField";

variablePie(Highcharts)

function CounterChart({data}) {
    const token = useSelector(selToken);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [option, setOption] = useState([
        {
            chart: {
                type: 'line',
                width: 1000,
                height: 400,
                style: {
                    marginBottom: "10px"
                },
                events: {
                    load: function(event) {
                        event.target.reflow();
                    }
                }
            },
            title: {
                text: 'تعداد سفارشات ثبت شده'
            },
            subtitle: {
                text: 'Source: WorldClimate.com'
            },
            xAxis: {
                categories: [],
            },
            // plotOptions: {
            //     line: {
            //         enableMouseTracking: false,
            //         marker: {
            //             enabled: true
            //         }
            //     }
            // },
            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    // pointStart: 2010
                }
            },
            series: [
                {
                    name: 'سفارش',
                    data: []
                },
                {
                    name: 'کاربر',
                    data: []
                }
            ]
        },
        {
            chart: {
                type: 'line',
                width: 1000,
                height: 300
            },
            title: {
                text: 'تعداد کاربران ثبت شده'
            },
            subtitle: {
                text: 'Source: WorldClimate.com'
            },
            xAxis: {
                categories: [],
            },
            plotOptions: {
                line: {
                    enableMouseTracking: false,
                    marker: {
                        enabled: false
                    }
                }
            },
            series: [{
                name: 'کاربر',
                data: []
            }]
        },
    ]);

    const Chart = ({options, highcharts}) => <HighchartsReact
        highcharts={highcharts}
        constructorType={'chart'}
        options={options}
    />;

    async function getInformation() {
        await axios({
            method: "get",
            url: strings.baseUrl + `admin/report/order`,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(result => {
                if (result.data.status_code === 200) {
                    Object.keys(result.data.data.report).forEach(item => {
                        option[0].xAxis.categories.push(item);
                        option[0].series[0].data.push(result.data.data.report[item]);
                    })
                } else if (result.data.status_code === 401) {
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            });
    }

    async function getUserInformation() {
        await axios({
            method: "get",
            url: strings.baseUrl + `admin/report/user`,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(result => {
                if (result.data.status_code === 200) {
                    Object.keys(result.data.data.report).forEach(item => {
                        option[1].xAxis.categories.push(item);
                        option[0].series[1].data.push(result.data.data.report[item]);
                        option[1].series[0].data.push(result.data.data.report[item]);

                    })
                } else if (result.data.status_code === 401) {
                    dispatch({type: "SET_ADMIN_TOKEN", data: ""})
                }
            })
            .catch(error => {
                console.log(error)
            });
        setLoading(false)
    }


    useEffect(() => {
        getInformation();
        getUserInformation();
        const dateForSet = [{
            chart: {
                type: 'variablepie',
                height:300,
            },
            title: {
                text: 'مقایسه وضعیت لایسنس ها'
            },
            tooltip: {
                headerFormat: '',
                pointFormat: '<b>{point.name}</b><span style="color:{point.color}">\u25CF</span><br/>' +
                    'تعداد: <b>{point.y}</b><br/>'

            },
            series: [{
                minPointSize: 100,
                zMax: 100,
                innerSize: 0,
                name: 'countries',
                data: [
                    // {
                    //     "name": 'لایسنس های فروخته شده',
                    //     "y": data[1] ? data[1]?.total_sold_licences : 50,
                    //     "z": 1000
                    // },
                    // {
                    //     "name": 'تعداد کل لایسنس ها',
                    //     "y": data[1] ? data[1]?.total_licences : 50,
                    //     "z": 1000
                    // },
                    // {
                    //     "name": 'لایسنس های فعال',
                    //     "y": data[1] ? data[1]?.total_active_licences : 50,
                    //     "z": 1000,
                    // },
                    {
                        "name": 'لایسنس های فروخته شده',
                        "y": data[1]?.total_sold_licences,
                        "z": 100
                    },
                    {
                        "name": 'تعداد کل لایسنس ها',
                        "y": data[1]?.total_licences,
                        "z": 90
                    },
                    {
                        "name": 'لایسنس های فعال',
                        "y": data[1]?.total_active_licences,
                        "z": 80,
                    },
                ]
            }]
        },
            {
                chart: {
                    type: 'variablepie',
                    height:300,
                },
                title: {
                    text: 'مقایسه وضعیت سفارشات'
                },
                tooltip: {
                    headerFormat: '',
                    pointFormat: '<b>{point.name}</b><span style="color:{point.color}">\u25CF</span><br/>' +
                        'تعداد: <b>{point.y}</b><br/>'
                },
                series: [{
                    minPointSize: 100,
                    zMax: 100,
                    innerSize: 0,
                    name: 'countries',
                    data: [
                        // {
                        //     "name": 'لایسنس های فروخته شده',
                        //     "y": data[1] ? data[1]?.total_sold_licences : 50,
                        //     "z": 1000
                        // },
                        // {
                        //     "name": 'تعداد کل لایسنس ها',
                        //     "y": data[1] ? data[1]?.total_licences : 50,
                        //     "z": 1000
                        // },
                        // {
                        //     "name": 'لایسنس های فعال',
                        //     "y": data[1] ? data[1]?.total_active_licences : 50,
                        //     "z": 1000,
                        // },
                        {
                            "name": 'تعداد کل سفارشات',
                            "y": data[2]?.total_successful_order,
                            "z": 100
                        },
                        {
                            "name": 'سفارشات معلق',
                            "y": data[2]?.total_pending_orders,
                            "z": 90
                        },
                        {
                            "name": 'سفارشات امروز',
                            "y": data[2]?.today_successful_order,
                            "z": 80,
                        },
                    ]
                }]
            },
        ]
        data[1] && setOption([...option,...dateForSet])
    }, [data]);

    useEffect(() => {
        if(option[2]){
            Highcharts.chart("pie-chart-profile", option[2]);
            Highcharts.chart("pie-chart-profile2", option[3]);
        }

    }, [option]);

    // function reportChartSize() {
    //
    // }
    //
    // useEffect(()=>{
    //     window.addEventListener('resize', reportChartSize);
    // },[])



    return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center chartParent">
            <div className="d-flex flex-column mt-5 w-100">

                <div className="d-flex w-100 justify-content-center">
                    <Chart options={option[0]} highcharts={Highcharts} width={800} height={300}/>
                </div>
                {/*<Chart options={option[1]} highcharts={Highcharts} width={800} height={300}/>*/}
                <div className="d-flex flex-column flex-md-row w-100 boxCharts mb-5">
                    <div className="parentChart">
                        <div className="chart-toggle-display" id="pie-chart-profile"/>
                    </div>
                    <div className="parentChart">
                        <div className="chart-toggle-display" id="pie-chart-profile2"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CounterChart;